"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./input-trim.directive"));
__export(require("./input-trim.module"));



//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/ng2-trim-directive/dist/index.js
// module id = ../../../../ng2-trim-directive/dist/index.js
// module chunks = 4